import {useState} from 'react';
import {
    IonPage,
    IonContent,
    IonInput,
    IonButton,
    IonSpinner, IonItem
} from '@ionic/react';
import { useNavigate } from 'react-router-dom';
import {useAuth} from '@/hooks/useAuth';
import './Login.css';

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const {login, isLoading, error} = useAuth();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const success = await login(email, password);

        if (success) {
            navigate('/dashboard', { replace: true });
        }
    };

    return (
        <IonPage>
            <IonContent fullscreen>
                <div id="ion-content-login"
                    className="bg-gradient-to-br from-stone-900 via-stone-800 to-stone-900"
                >

                    <div id="login-card">

                        <div className="space-y-8">

                            <div className="flex justify-center mb-12">
                                <img
                                    src="/assets/logos/saplab-logo-dark.svg"
                                    alt="SapLab"
                                    id="saplab-logo-login"
                                />
                            </div>

                            <div
                                className="bg-stone-800/80 backdrop-blur-sm rounded-2xl p-8 shadow-2xl border border-stone-700">

                                <form onSubmit={handleSubmit} id="login-form">

                                    <IonItem className="rounded-xl" color="dark" lines="none">
                                        <IonInput
                                            type="email"
                                            placeholder="Email"
                                            value={email}
                                            onIonInput={(e) => setEmail(e.detail.value!)}
                                            required
                                        />
                                    </IonItem>

                                    <IonItem className="rounded-xl" color="dark" lines="none">
                                        <IonInput
                                            type="password"
                                            placeholder="Mot de passe"
                                            value={password}
                                            onIonInput={(e) => setPassword(e.detail.value!)}
                                            required
                                        />
                                    </IonItem>

                                    {error && (
                                        <div
                                            className="bg-red-900/30 border border-red-500 text-red-300 px-6 py-4 rounded-xl text-base text-center">
                                            {error}
                                        </div>
                                    )}

                                    <IonButton
                                        type="submit"
                                        expand="block"
                                        id="login-button"
                                        disabled={isLoading}
                                        color="warning"
                                        className="mt-8 h-14 text-lg font-semibold"
                                    >
                                        {isLoading ? (
                                            <div className="flex items-center gap-3">
                                                <IonSpinner name="crescent"/>
                                                <span>Connexion...</span>
                                            </div>
                                        ) : (
                                            'Se connecter'
                                        )}
                                    </IonButton>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    );
};


export default Login;